export const surveys = [
  {
    surveyName: "General Survey",
    description: "Give us your feedback on all things Pulse",
    link: "/general-survey",
    isAnswered: true,
  },
  {
    surveyName: "Loyalty Survey",
    description: "Give us your feedback on various Loyalty features",
    link: "/loyalty-survey",
    isAnswered: false,
  },
  {
    surveyName: "Events Survey",
    description: "Give us your feedback on Events",
    link: "/events-survey",
    isAnswered: true,
  },
  {
    surveyName: "Offers Survey",
    description: "Give us your feedback on Pulse Offers",
    link: "/offers-survey",
    isAnswered: false,
  },
  {
    surveyName: "Gaming Survey",
    description: "Give us your feedback on Gaming on Pulse",
    link: "/gaming-survey",
    isAnswered: true,
  },
];
